<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { useDisciplineProgressReportsStore } from '../model/progress-reports/store'
import { abortDisciplineProgressReportsApi, useDisciplineProgressReportsApi } from '../api/progress-reports.hook'
import DisciplinePageLoader from './DisciplinePageLoader.vue'
import TableDisciplineProgressReports from './TableDisciplineProgressReports.vue'
import ModalDisciplineProgressReport from './modals/ModalDisciplineProgressReport.vue'

defineOptions({
  name: 'DisciplineProgressReportsPage',
})

const route = useRoute()
const store = useDisciplineProgressReportsStore()

/** The first list read shares the page loader with the discipline, so the tab appears with its rows in place; a
 *  Search or a page change keeps the rows and only locks the controls. */
const refIsFirstLoad = computed<boolean>(() => store.isLoading && store.getMeta === null)

const fetchReports = (): void => {
  void useDisciplineProgressReportsApi({ disciplineId: route.params.id as string })
}

onMounted(fetchReports)

// Filters and pagination navigate by query; the middleware has already written them to the store.
watch(() => route.query, () => {
  if (route.name === 'disciplines-id-progress-reports') fetchReports()
})

// Timestamps arrive pre-shifted into the admin's view timezone, so a timezone change needs a refetch.
useOnTimezoneChange(fetchReports)

onBeforeUnmount(() => {
  abortDisciplineProgressReportsApi()
  store.setEditingReport(null)
  store.resetList()
})
</script>

<template>
  <DisciplinePageLoader :loading="refIsFirstLoad" />
  <TableDisciplineProgressReports />
  <ModalDisciplineProgressReport />
</template>
